import dayjs from 'dayjs';
import dayjscalendar from 'dayjs/plugin/calendar';
import dayjslocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjstimezone from 'dayjs/plugin/timezone';
import dayjsutc from 'dayjs/plugin/utc';

dayjs.extend(dayjscalendar);
dayjs.extend(dayjslocalizedFormat);
dayjs.extend(dayjstimezone);
dayjs.extend(dayjsutc);

export function doesDateStringContainOffset(date: string): boolean {
	return date.endsWith('Z') || (/[+-]\d\d:\d\d$/u).test(date);
}

export function getLocalDateTime(date: string): dayjs.Dayjs {
	return doesDateStringContainOffset(date) ? dayjs(date) : dayjs(`${date}+00:00`).utc(true);
}

export function getDate(date: string): dayjs.Dayjs {
	const trimmedDate = date.includes('T') ? date.slice(0, date.indexOf('T')) : date;
	const utcDate = dayjs.utc(trimmedDate);

	return utcDate;
}

export function getCalendarDateTime(date: string): string {
	return getLocalDateTime(date).format('YYYY-MM-DD h:mma');
}

export function getShortDate(date: string): string {
	return getLocalDateTime(date).format('M/D/YY');
}

export function getTimeRecordDate(date: string): string {
	return getLocalDateTime(date).format('M/D/YY h:mm a');
}

export function convertISODateToHumanReadableDate(date: string): string {
	return getLocalDateTime(date).format('dddd, MMMM Do YYYY, h:mm:ss a');
}

export function convertISODateToShortDate(date: string): string {
	return getLocalDateTime(date).format('MMM D YYYY, h:mm:ss a');
}

export function convertISODateToEventDate(date: string): string {
	return getLocalDateTime(date).format('M/D/YYYY, h:mm:ss A z');
}

export function convertISODateToPardotDate(date: string): string {
	return getLocalDateTime(date).format('MMM D, YYYY h:mm a');
}

export function getPastDate(daysAgo: number): string {
	return dayjs().startOf('day')
		.subtract(daysAgo, 'day')
		.format('YYYY-MM-DD');
}
